import { DatePicker } from '@3plearning/react-components';
import isEqual from 'lodash/isEqual';
import {
    DATE_OPTION_TO_PATH_MAP,
    DATE_PARAM_MAP,
    DATE_TYPE,
    START_DATE,
    END_DATE,
    MATHLETICS_ID
} from './constants';
import UrlHelper from './url-helper';

/**
 * Helps to generate the request URL when making requests for activity mastery, participation
 * or live maths data
 */
export default class DateParamHelper {
    static getDateQueryParams(selectedDate) {
        const params = { productId: MATHLETICS_ID };
        if (selectedDate.type === DatePicker.CUSTOM_DATE) {
            params.startDate = selectedDate.startDate;
            params.endDate = selectedDate.endDate;
        }
        return params;
    }

    static getDateTypePath(selectedDate) {
        return {
            dateType: DATE_OPTION_TO_PATH_MAP[selectedDate.type]
        };
    }

    static areDatesEqual(firstDate, secondDate) {
        if (isEqual(firstDate, secondDate)) {
            return true;
        }

        const { type: firstType } = firstDate;
        const { type: secondType } = secondDate;
        return firstType === secondType && firstType !== DatePicker.CUSTOM_DATE;
    }

    static getInitialDate() {
        return {
            type:
                DATE_PARAM_MAP[UrlHelper.getQueryParamValue(DATE_TYPE)] ||
                DatePicker.THIS_SCHOOL_YEAR,
            startDate: UrlHelper.getQueryParamValue(START_DATE) || null,
            endDate: UrlHelper.getQueryParamValue(END_DATE) || null
        };
    }
}



// WEBPACK FOOTER //
// ./helpers/date-param-helper.js